// extracted by mini-css-extract-plugin
module.exports = {"offset-input":"styles-module__offset-input___223tl"};